<template>
  <div id="provisionalRemedyAnswerContainer" class="container-fluid">
    <!-- page header -->
    <page-header
      :page="page"
      :has-return="true"
      @onReturn="() => $router.back()"
    />

    <!-- main filter -->
    <MainFilter ref="filter" />

    <!-- separator -->
    <div class="mt-4">
      <CustomSeparator text="Historial de COMPU" />
    </div>

    <!-- results -->
    <div class="row">
      <div class="col">
        <time-line class="mt-4">
          <time-line-item
            v-for="(item, index) in results"
            :key="index"
            icon="fa fa-file-user"
          >
            <template #date>
              <span class="meeting-date-title">Fecha Reunión:</span>
              <p class="meeting-date-value">
                {{
                  $formatDate(
                    item.placementCommitteeDate,
                    $templateDate.default
                  )
                }}
              </p>
            </template>
            <div id="main-info" class="row">
              <div class="col additional-evaluation">
                <strong v-if="!item.impedimentId">
                  Discusión de Evaluación
                </strong>
                <strong>{{ item.placementCommitteeCategory }}</strong>
                <span>{{ item.academicYear }}</span>
              </div>
              <div class="col">
                <label class="info-field-title">Elegible:</label>
                <label v-if="item.eligibilityFlag" class="info-field-value">
                  {{ item.eligibilityFlag | booleanConverter }}
                </label>
                <label v-else class="info-field-value">NA</label>
              </div>
              <div class="col">
                <label class="info-field-title">Fecha de Elegibilidad:</label>
                <label class="info-field-value">
                  {{
                    $formatDate(
                      item.eligibilityDeterminationDate,
                      $templateDate.default
                    ) || 'NA'
                  }}
                </label>
              </div>
              <div class="col">
                <label class="info-field-title">Impedimento:</label>
                <label class="info-field-value">
                  {{ item.impedimentDesc || 'NA' }}
                </label>
              </div>
              <div
                class="col-md-2 col-sm-12 text-right pr-5"
              >
                <div class="dropdown">
                  <button
                    id="ddAdiestramiento"
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                  <div class="dropdown-menu" aria-labelledby="ddAdiestramiento">
                    <a v-if="!item.impedimentId && item.placementCommitteeId > 0"
                      class="btn dropdown-item"
                      @click="
                        goToEvalDiscussionDetails(item.placementCommitteeId)
                      "
                    >
                      <i class="fas fa-eye text-green mr-1" />
                      Ver detalle
                    </a>
                    <a
                      v-if="item.evaluationDateId"
                      class="btn dropdown-item"
                      @click="
                        downloadSaee05Report(
                          item.evaluationDateId
                        )
                      "
                    >
                      <i class="fas fa-print text-green mr-1" />
                      SAEE-05
                    </a>
                    <a
                      v-if="nonDetermineStudentEvaluationIds(item.studentEvaluations).length"
                      class="btn dropdown-item"
                      @click="
                        downloadSaee03cReport(item)
                      "
                    >
                      <i class="fas fa-print text-green mr-1" />
                      SAEE-03c
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="info-panel info-panel">
                <div v-if="item.impedimentId" class="disciplines">
                  <div class="row">
                    <div class="col">
                      <div class="info-panel-main-title">
                        <em class="fas fa-info-circle" />
                        <span>Evaluaciones:</span>
                      </div>
                    </div>
                  </div>
                  <div class="info-panel-container">
                    <div class="info-panel-item">
                      <span
                        v-for="(disciplineName, index) in item.disciplineNames"
                        :key="index"
                        class="mt-2"
                      >
                        {{ disciplineName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="comment">
                  <div class="row">
                    <div class="col">
                      <div class="info-panel-main-title">
                        <em class="fas fa-info-circle" />
                        <span>Comentario:</span>
                      </div>
                    </div>
                  </div>
                  <div class="info-panel-container">
                    <div class="info-panel-item">
                      <label>{{ item.determinationComment }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </time-line-item>
        </time-line>

        <div v-if="hasShowMore" class="row">
          <div class="col text-center">
            <action-button
              variant="outline-success custom-view-more"
              i="fas fa-chevron-down"
              @click="loadMore"
            >
              Ver más Reuniones
            </action-button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="results.length == 0"
      class="col-12 p-4 text-center align-items-center no-info mt-4"
    >
      <div class="row justify-content-center">
        <div class="col-12 col-lg-1 align-self-center">
          <i class="far fa-folder-open icon no-info-icon pl-2" />
        </div>
        <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
          <span class="no-info-text">No hay información disponible.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import { MainFilter } from './components';
import CustomSeparator from '@/components/common/CustomSeparator';
import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import { ActionButton } from '@/components/common';

import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
const {
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
} = createNamespacedHelpers(modulesName.studentCompuHistoryModuleName);
import * as studentCompuHistoryTypes from '@/modules/student-compu-history/store/types.js';
import compuHistoryServices from '@/modules/student-compu-history/api';
import placementCommitteeCategory from '@/utils/constants/student/placementCommitteeCategory';
import generalService from '@/services/pei/general';
import studentEvaluationService from '@/modules/student-evaluations/api';
import reportService from '@/services/report';
import alertMixin from "@/mixin/alert.mixin";

export default {
  name: 'CompuHistoryMain',
  components: {
    PageHeader,
    MainFilter,
    CustomSeparator,
    TimeLine,
    TimeLineItem,
    ActionButton,
  },
  mixins: [alertMixin],
  filters: {
    booleanConverter: (value) => (value ? 'Si' : 'No'),
  },
  data() {
    return {
      page: {
        icon: 'fas fa-history',
        title: 'Historial de COMPU',
        routes: ['Inicio', 'Estudiantes', 'Historial de COMPU'],
      },
      studentSieId: 0,
      regStudentId: null,
      canUpdateInfo: false,
      placementCategory: placementCommitteeCategory,
    };
  },
  computed: {
    ...mapState({
      results: (state) => state.results.data,
    }),
    ...mapGetters({
      hasShowMore: 'getHasShowMore',
    }),
    headerActionConfig() {
      return [
        {
          text: 'Actualizar Elegibilidad / Imp',
          icon: 'fas fa-user',
          variant: 'outline-success',
          click: () => {
            this.updateImpedimentInfo(this.studentSieId);
          },
          visible: this.canUpdateInfo,
        },
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.back();
          },
          visible: true,
        },
      ];
    },
    nonDetermineStudentEvaluationIds() {
      return (studentEvaluations) => (studentEvaluations?.filter(x => !x.isDetermination).map(s => s.studentEvaluationId) || []);
    },
  },
  methods: {
    ...mapMutations(['setMoreRows']),
    ...mapActions([studentCompuHistoryTypes.ACTION_TYPES.GET_RESULTS_FILTERED]),
    loadMore() {
      this.setMoreRows();
    },
    searchCompuHistory() {
      const filters = {
        studentSieId: this.studentSieId,
      };

      this[studentCompuHistoryTypes.ACTION_TYPES.GET_RESULTS_FILTERED](filters);
    },
    async canUpdateImpedimentInfo() {
      await compuHistoryServices
        .canUpdateImpedimentInfo(this.studentSieId)
        .then((res) => {
          this.canUpdateInfo = res.data;
        });
    },
    async updateImpedimentInfo() {
      await compuHistoryServices
        .updateImpedimentInfo(this.studentSieId)
        .then(() => {
          this.searchCompuHistory({ loadMore: false });
          this.canUpdateImpedimentInfo();
          this.changeSelectedStudentImpediment();
        });
    },
    changeSelectedStudentImpediment() {
      this.$store.state.$_student.selectedStudent.impediment = this.results[0].impedimentDesc;
    },
    goToEvalDiscussionDetails(placementCommitteeId) {
      this.$router.push({
        name: 'MainEvaluationDiscuss',
        params: { studentSIE: this.studentSieId, placementCommitteeId: placementCommitteeId },
      });
    },
    async downloadSaee05Report(evaluationDateId) {
      try {
        if(evaluationDateId) {
          const { data } = await this.$ApiGet(`/api/studentevaluation/${this.studentSieId}/EligibilityDeterminationForm/${evaluationDateId}`);          
          generalService.documentDownloadReport(
            data.content,
            data.filename
          );
        }
        else {
          this.ShowToast(
            "Alerta",
            "reporte no puede ser descargado.",
            "warning"
          ); 
        }
      } catch (error) {
        this.ShowToast(
          "Alerta",
          "Ha ocurrido un error al intentar descargar el reporte.",
          "warning"
        ); 
      }
    },
    async downloadSaee03cReport({ studentEvaluations }) {
      try {
        if(this.nonDetermineStudentEvaluationIds(studentEvaluations).length) {
          await reportService.downloadMultipleSaee03cReports(this.nonDetermineStudentEvaluationIds(studentEvaluations));
        }
        else {
          this.ShowToast(
            "Alerta",
            "reporte no puede ser descargado.",
            "warning"
          ); 
        }
      } catch (error) {
        this.ShowToast(
          "Alerta",
          "Ha ocurrido un error al intentar descargar el reporte.",
          "warning"
        ); 
      }
    },
  },
  mounted() {
    this.regStudentId = this.$store.getters.SelectedStudent.regStudentId;
    this.studentSieId = this.$store.getters.SelectedStudent.studentId;
    this.searchCompuHistory({ loadMore: false });
    this.canUpdateImpedimentInfo();
  },
};
</script>

<style scoped lang="scss">
$collapseOpenColor: #bcbec0;
$collapseCloseColor: #ff7058;
$colorWhite: #fff;

#main-info {
  margin: 0px 10px;
  .additional-evaluation {
    margin-bottom: 14px;
    strong {
      text-align: left;
      font: Bold 18px/21px Lato;
      letter-spacing: 0px;
      color: #36484b;
      display: block;
    }
    span {
      text-align: left;
      font: Regular 14px/21px Lato;
      letter-spacing: 0px;
      color: #36484b;
    }
  }
}

.meeting-date-title {
  text-align: left;
  font-size: 13px;
  letter-spacing: 0px;
  color: #727272;
}

.meeting-date-value {
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0px;
  color: #11291b;
}

.info-field-title {
  text-align: left;
  font: Regular 14px/28px Lato;
  letter-spacing: 0px;
  color: #727272;
  display: block;
}
.info-field-value {
  text-align: left;
  font: Regular 16px/28px Lato;
  letter-spacing: 0px;
  color: #11291b;
}

.info-panel {
  margin-left: -13px;
  margin-right: -13px;
  margin-bottom: -13px;
  padding: 15px 10px 1px 33px;
  border-bottom: none;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
  background: $colorWhite;
  .info-panel-main-title {
    em {
      color: $collapseCloseColor;
    }
    span {
      text-align: left;
      font: Bold 16px/19px Lato;
      letter-spacing: 0px;
      color: #3f5b60;
      opacity: 1;
      margin-left: 7px;
    }
  }
  .info-panel-container {
    display: flex;
    flex-flow: row wrap;
    padding: 0px 10px 1px 23px;
    .info-panel-item {
      flex: 1 0 25%;
      margin-bottom: 1.5em;
      float: left;
      box-sizing: border-box;
      padding-right: 10px;
      span {
        display: block;
        text-align: left;
        font: Regular 14px/28px Lato;
        letter-spacing: 0px;
        color: #727272;
      }
      label {
        margin-top: 10px;
        text-align: left;
        font: Regular Lato;
        font-size: 1rem;
        letter-spacing: 0px;
        color: #11291b;
        line-height: 1.6em;
      }
    }
  }
}

/* Customize timeline  */
.timeline__container {
  ::v-deep .icon-absolute {
    em {
      padding-top: 11px;
    }
  }
  ::v-deep .timeline__content::before {
    left: -38px;
  }
  ::v-deep .timeline__content:after {
    top: 36px;
    left: -42px !important;
  }
}

.custom-view-more {
  border-radius: 50px;
  padding: 10px 20px 10px 20px;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
  .no-info-text {
    text-align: left;
    font: Bold 16px/22px Lato;
    letter-spacing: 0;
    color: #727272;
    opacity: 1;
  }
  .no-info-icon {
    color: #727272;
    font-size: 32px;
  }
}
</style>
